export default __webpack_public_path__ + "static/media/conceptual_architecture_01.0fe044fa.png";